import gatewayService from '@/modules/common/services/gatewayService';

const baseRoute = '/business/subscriptionsmng/v1';
const baseRouteV3 = '/v3';

const createSubscription = async (params) => gatewayService.post(`${baseRoute}/subscriptions`, params)
  .then((res) => res.data.data.subscription);

const purchaseItemSubscription = async (itemUid, item) => gatewayService.post(`${baseRoute}/subscriptions/items/${itemUid}`, { item })
  .then((res) => res.data.data.subscriptionsPayPerUnit[0]);

const createV3Subscription = async (params) => gatewayService.post(`${baseRouteV3}/license/subscriptions`, params)
  .then((res) => res.data.data);

const cancelSubscription = async (subscriptionUid) => gatewayService.put(`${baseRoute}/subscriptions/${subscriptionUid}`, {
  subscription: {
    purchase_state: 'canceled',
  },
});

const cancelV3Subscription = async (subscriptionUid) => gatewayService.put(`${baseRouteV3}/license/subscriptions/${subscriptionUid}`, {
  purchase_state: 'canceled',
}).then((res) => res.data.data);

const getOfferings = async (params) => gatewayService.get(`${baseRouteV3}/license/offerings?${params}`)
  .then((res) => res.data.data);

const getAccount = async () => gatewayService.get(`${baseRoute}/accounts`).then((res) => res.data.data);

const getSubscriptionByUid = async (subscriptionUid) => gatewayService.get(`${baseRoute}/subscriptions?[filter][uid]=${subscriptionUid}`)
  .then((res) => res.data.data.subscriptions[0]);

const hasActiveSubscriptionToApp = async (appCodeName) => {
  try {
    const result = await gatewayService.get(`${baseRouteV3}/license/subscriptions?is_active=true&sku=${appCodeName}`);
    // Return true if there are any active subscriptions for this app
    return result?.data?.data?.subscriptions?.length > 0;
  } catch (error) {
    console.error('Error checking active subscription for app:', appCodeName, error);
    return false;
  }
};

const getSubscriptionDetails = async () => {
  const accountDetails = await getAccount();
  const result = await getSubscriptionByUid(accountDetails.main_subscription_uid);
  const purchasables = await gatewayService.get(`${baseRoute}/purchasables?page=1&per_page=50&filter[purchasable_type]=package&filter[uid]=${result.purchasable_uid}`);
  result.purchasable_item_uid = purchasables.data.data.purchasables[0].item_uid;

  return result;
};

const getActiveSubscriptions = async () => {
  try {
    const result = await gatewayService.get(`${baseRouteV3}/license/subscriptions?is_active=true`);
    return result.data.data.subscriptions;
  } catch (error) {
    console.error('Error fetching active subscriptions:', error);
    throw new Error(`Failed to fetch active subscriptions: ${error.message || error}`);
  }
};

const getPurchasableApps = async (appCodeNames) => {
  try {
    const result = await gatewayService.get(`${baseRoute}/purchasables?page=1&per_page=50&filter[purchasable_type][eq]=app&filter[vendor][eq]=inTandem&filter[is_active][eq]=1&filter[item_uid][in]=${appCodeNames.join(',')}`);

    return result.data.data.purchasables.reduce((map, obj) => {
      const updatedMap = { ...map };
      updatedMap[obj.uid] = obj;
      return updatedMap;
    }, {});
  } catch (error) {
    console.error('Error fetching purchasable apps:', error);
    throw new Error(`Failed to fetch purchasable apps for [${appCodeNames.join(', ')}]: ${error.message || error}`);
  }
};

export default {
  createSubscription,
  purchaseItemSubscription,
  cancelSubscription,
  cancelV3Subscription,
  getSubscriptionDetails,
  getSubscriptionByUid,
  hasActiveSubscriptionToApp,
  getActiveSubscriptions,
  getPurchasableApps,
  createV3Subscription,
  getOfferings,
};
